import { ChevronDown, ChevronUp, Locate } from "lucide-react";

import { Button } from "@/components/ui/button";

export type PlaybookScriptItemNextPrevProps = {
  onPrevious: () => void;
  onNext: () => void;
  onLocate: () => void;
};
export const PlaybookScriptItemNextPrev = ({
  onPrevious,
  onNext,
  onLocate,
}: Readonly<PlaybookScriptItemNextPrevProps>) => {
  return (
    <div className="flex flex-row space-x-2">
      <Button variant="ghost" className="h-auto px-2 py-2" onClick={onPrevious}>
        <ChevronUp size={12} />
      </Button>
      <Button variant="ghost" className="h-auto px-2 py-2" onClick={onLocate}>
        <Locate size={12} />
      </Button>
      <Button variant="ghost" className="h-auto px-2 py-2" onClick={onNext}>
        <ChevronDown size={12} />
      </Button>
    </div>
  );
};
